import { createSelector } from 'reselect';

import getAllBackgrounds from './getAllBackgrounds';
import { BackgroundGarmentMarkersType } from 'src/types/decorationSpecs';

/** Every background's calibrated garment markers, flattened with the background's id — mirrors
 * `getAllCylinderWarps`, but over backgrounds rather than documents. Used when saving a scene to
 * collect the markers that ride in the revision's `metadata.markers` side-channel (see
 * `src/services/converters/garmentMarkers.ts`). */
const getAllGarmentMarkers = createSelector([getAllBackgrounds], (backgrounds) =>
    backgrounds
        .filter((background) => background.garmentMarkers)
        .map((background) => ({ id: background.id, ...background.garmentMarkers }) as BackgroundGarmentMarkersType),
);

export default getAllGarmentMarkers;
